import React from "react";
import { connect } from "react-redux";
import { Merge } from "../../models";
import { Content, Container } from "../../pages/Template";

import Header from "./Header";
import Requests from "./Requests";
import { setWindowTitle } from "../../helpers";
import { AppState } from "../../store";
import { AxiosResponse } from "axios";

type OwnProps = {
    match: {
        params: {
            doc_id: string;
        };
    };
};

const mapState = (
    _: AppState,
    {
        match: {
            params: { doc_id },
        },
    }: OwnProps
) => ({
    doc_id: parseInt(doc_id),
});
type StateProps = ReturnType<typeof mapState>;

export interface MergeRequest {
    id: number;
    num: number;
    name: string;
    doc_id: number;
    status: string;
    created_at: string;

    src_user_id: number;
    dst_user_id: number;

    src_page_contents_id: number;
    dst_page_contents_id: number;

    src_user_name: string;
    dst_user_name: string;
}

type Props = StateProps;
type State = {
    requests: Array<MergeRequest>;
};

class MergeRequestsPage extends React.Component<Props, State> {
    static paths = ["/app/merge/request/:doc_id/"];
    static requiresAuth = true;

    constructor(props: Props) {
        super(props);
        this.state = {
            requests: [],
        };
    }

    componentDidMount() {
        this.fetch();
        setWindowTitle("کام ملانے کے پیغامات");
    }

    async fetch() {
        try {
            const { doc_id } = this.props;
            const { data }: AxiosResponse<MergeRequest> = await Merge.fetch(
                "",
                {
                    doc_id,
                }
            );
            this.setState({ requests: [data] });
        } catch (e) {}
    }

    render() {
        return (
            <Content>
                <Container width="1000px">
                    <Header />
                    <Requests requests={this.state.requests} />
                </Container>
            </Content>
        );
    }
}

export default connect(mapState)(MergeRequestsPage);
